import styled from 'styled-components'
import { VARIABLES } from '../../themes'

// Wrapper
// ============================================================
export const TabberStyle = styled.div`
  /* Parent
  ------------------------------- */
  width: 100%;

  /* Childrens
  ------------------------------- */
  .react-tabs__tab-list {
    display: flex;
    border-bottom: 0;
    position: relative;
    margin-bottom: 30px;

    &:before {
      content: '';
      position: absolute;
      z-index: 0;
      width: 100%;
      height: 100%;
      border: 1px solid ${VARIABLES.COLORS.GRAY_2};
      border-radius: ${VARIABLES.BORDER_RADIUSES.XS};
      top: 1px;
    }
  }

  .react-tabs__tab {
    border: 0;
    font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_NORMAL};
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;
    height: 60px;
    color: ${VARIABLES.COLORS.BLUE_1};
    background-color: transparent;
    padding: 5px;
    line-height: 1.2;
    flex-grow: 1;

    &:focus {
      box-shadow: none;
      border-color: ${VARIABLES.COLORS.TRANSPARENT};
    }

    &:hover {
      background-color: ${VARIABLES.COLORS.BLUE_1};
      color: ${VARIABLES.COLORS.WHITE};
      border-radius: ${VARIABLES.BORDER_RADIUSES.XS};
    }
  }

  .react-tabs__tab--selected {
    background-color: ${VARIABLES.COLORS.BLUE_1};
    border-radius: ${VARIABLES.BORDER_RADIUSES.XS};
    color: ${VARIABLES.COLORS.WHITE};
  }

  .react-tabs__tab--disabled {
    color: ${VARIABLES.COLORS.GRAY_5};
    cursor: not-allowed;

    &:hover {
      background-color: ${VARIABLES.COLORS.TRANSPARENT};
      color: ${VARIABLES.COLORS.GRAY_5};
    }
  }

  .theme-sub-tabs {
    .react-tabs__tab-list:before {
      border: none;
      border-radius: 0;
      border-bottom: 1px solid ${VARIABLES.COLORS.GRAY_2};
    }

    .react-tabs__tab {
      padding: 8px 30px;
      margin-right: 8px;
      height: 45px;
      flex-grow: inherit;
      border: 1px solid ${VARIABLES.COLORS.GRAY_2};
      border-bottom: 0;
      border-radius: 2px;

      &.hover {
        border-radius: 0;
      }
    }

    .react-tabs__tab--selected {
      background-color: ${VARIABLES.COLORS.WHITE};
      color: ${VARIABLES.COLORS.BLUE_1};
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_SEMI_BOLD};

      &:hover {
        background-color: ${VARIABLES.COLORS.WHITE};
        color: ${VARIABLES.COLORS.BLUE_1};
      }
    }

    .react-tabs__tab--disabled {
      color: ${VARIABLES.COLORS.GRAY_5};
      cursor: not-allowed;
    }
  }

  .blogs {
    .react-tabs__tab-panel {
        padding: 30px;
        border: 1px solid ${VARIABLES.COLORS.GRAY_2};
        margin-top: -30px;
        margin-bottom: 0;
    }
  }
  
  /* Modifiers
  ------------------------------- */
  .react-tabs__tab {
    &.theme-transparent {
      padding: 8px 30px;
      margin-left: 3px;
      margin-right: 5px;
      height: 44px;
      flex-grow: inherit;

      &.react-tabs__tab--selected {
        border-left: 1px solid ${VARIABLES.COLORS.GRAY_2};
        border-right: 1px solid ${VARIABLES.COLORS.GRAY_2};
        border-top: 1px solid ${VARIABLES.COLORS.GRAY_2};
        background-color: ${VARIABLES.COLORS.WHITE};
        color: ${VARIABLES.COLORS.BLUE_1};
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_SEMI_BOLD};
        border-top-left-radius: 2px;
        border-top-right-radius: 2px;

        &:hover {
          background-color: ${VARIABLES.COLORS.WHITE};
          color: ${VARIABLES.COLORS.BLUE_1};
        }
      }

      &.react-tabs__tab--disabled {
        color: ${VARIABLES.COLORS.GRAY_5};
        cursor: not-allowed;
      }
    }
  }

  /* &.supplier-discovery {
    .react-tabs__tab-list {
      margin-left: ${VARIABLES.ELEMENT_SIZES.SUPPLIER_TAB_PADDING_LEFT + 'px'};
    }

    & > div {
      & > .react-tabs__tab-list {
        & > .react-tabs__tab {
          width: 50%;
        }
      }
    }
  } */

  /* &.supplier-information {
    & > div {
      & > .react-tabs__tab-list {
        & > .react-tabs__tab {
          width: 14.28%;
          //padding: 0;
          text-align: center;
          line-height: 1.1;

          &.long-text {
            width: 15%;
          }
        }
      }
    }
  } */

  &.comprehensive-assessment-management {
    & > div {
      & > .react-tabs__tab-list {
        & > .react-tabs__tab {
          width: 50%;
          padding: 0;
          text-align: center;
          line-height: 1.1;
        }
      }
    }
  }

  /* &.financial-score {
    & > div {
      & > .react-tabs__tab-list {
        margin-bottom: 0;

        & > .react-tabs__tab {
          width: 33.33%;
          border-bottom-left-radius: 0;
          border-bottom-right-radius: 0;
        }
      }
    }
  } */

  /* Media queries
  ------------------------------- */
  @media all and (max-width: 1680.98px) {
    /* &.supplier-discovery {
      .react-tabs__tab-list {
        margin-left: ${
          VARIABLES.ELEMENT_SIZES.SUPPLIER_TAB_PADDING_LEFT_XXL + 'px'
        };
      }
    } */
  }

  @media all and (max-width: 1600.98px) {
    /* .react-tabs__tab {
      height: 47px;
    }

    &.supplier-discovery {
      .react-tabs__tab-list {
        margin-left: ${
          VARIABLES.ELEMENT_SIZES.SUPPLIER_TAB_PADDING_LEFT_XL + 'px'
        };
      }
    } */
  }

  /* Start max-width: '1439px'*/
  @media all and (max-width: ${VARIABLES.BREAKPOINTS.DESKTOP_SM_MAX}) {
    .react-tabs__tab {
      max-height: 35px;
    }

    .blogs {
      .react-tabs__tab-panel {
        padding: 20px;
      }
    }
  }

  @media all and (max-width: 1440.98px) {
    /* .react-tabs__tab {
      height: 44px;
    }

    &.supplier-discovery {
      .react-tabs__tab-list {
        margin-left: ${
          VARIABLES.ELEMENT_SIZES.SUPPLIER_TAB_PADDING_LEFT_LG + 'px'
        };
      }
    } */
  }

  @media all and (max-width: 1366.98px) {
    /* .react-tabs__tab {
      height: 41px;
    } */

    /* .react-tabs__tab-list {
      &:before {
        border-width: 1px;
      }
    } */

    /* &.supplier-discovery {
      .react-tabs__tab-list {
        margin-left: ${
          VARIABLES.ELEMENT_SIZES.SUPPLIER_TAB_PADDING_LEFT_MD + 'px'
        };
      }
    } */
  }

  @media all and (max-width: 1280.98px) {
    /* .react-tabs__tab {
      height: 38px;
    }

    &.supplier-discovery {
      .react-tabs__tab-list {
        margin-left: ${
          VARIABLES.ELEMENT_SIZES.SUPPLIER_TAB_PADDING_LEFT_SM + 'px'
        };
      }
    } */
  }

  @media all and (max-width: 1024.98px) {
    /* .react-tabs__tab {
      height: 35px;
    }

    &.supplier-discovery {
      .react-tabs__tab-list {
        margin-left: ${
          VARIABLES.ELEMENT_SIZES.SUPPLIER_TAB_PADDING_LEFT_XS + 'px'
        };
      }
    } */
  }
`
